export class CropperDrawSettings {
    public strokeWidth: number = 1;
    public strokeColor: string = "rgba(255,255,255,1)";
}



// WEBPACK FOOTER //
// ./node_modules/ng2-img-cropper/src/cropperDrawSettings.ts